var _a;
import { getDisplayMeetingStatus, MeetingStatus } from '@govinity/validation';
import { PauseCircle, Radio } from 'lucide-react';
import { startCase } from 'lodash';
import { isRecessStatusDisplay, RECESS_BADGE_CLASS } from './status-label-helpers';
import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { StatusBadge } from '../ui/status-badge';
export var STATUS_VARIANT = (_a = {},
    _a[MeetingStatus.Upcoming] = 'info-alt2',
    _a[MeetingStatus.Live] = 'default',
    _a[MeetingStatus.Completed] = 'success',
    _a[MeetingStatus.Cancelled] = 'danger',
    _a);
/**
 * Badge for a meeting's status. Pass `date` and `timezone` so a meeting left flagged upcoming after
 * its day has passed reads as completed, matching the public portal — see
 * {@link getDisplayMeetingStatus}. Without them the stored status is shown verbatim. Pass `isRecessed`
 * (a backend-computed flag, not raw `meetingPhase`) so a live meeting in recess reads "In Recess".
 */
export function MeetingStatusLabel(_a) {
    var className = _a.className, date = _a.date, _b = _a.isRecessed, isRecessed = _b === void 0 ? false : _b, status = _a.status, timezone = _a.timezone;
    var displayStatus = date && timezone ? getDisplayMeetingStatus({ date: date, status: status, timezone: timezone }) : status;
    if (isRecessStatusDisplay(displayStatus, isRecessed)) {
        return (<Badge className={cn(RECESS_BADGE_CLASS, className)}>
        <PauseCircle className="h-3.5 w-3.5" aria-hidden="true"/>
        In Recess
      </Badge>);
    }
    if (displayStatus === MeetingStatus.Live) {
        return (<Badge variant="default" className={className}>
        <Radio className="h-3.5 w-3.5"/>
        {startCase(displayStatus)}
      </Badge>);
    }
    return (<StatusBadge variant={STATUS_VARIANT[displayStatus]} className={className}>
      {startCase(displayStatus)}
    </StatusBadge>);
}
